import React, { useState, useEffect } from "react";
import "./index.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { ReactComponent as Nysc } from "../../Assets/LandingPage/Nysc-logo.svg";
import { Link } from "react-router-dom"; 
import { useSelector, useDispatch } from "react-redux";

import { getSystemSettings } from "../../Actions";

const Header = () => {
  const dispatch = useDispatch();

  const settingsState = (state) => state.systemSettings;
  const { systemSettings } = useSelector(settingsState);

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click); 

  window.addEventListener("scroll", (e) => {
    const nav = document?.querySelector(".nav-package");
    if (window.scrollY > 0) {
      nav?.classList?.add("add-shadow");
    } else {
      nav?.classList?.remove("add-shadow");
    }
  });

  useEffect(() => {
    dispatch(getSystemSettings());
  }, [dispatch]);

  return (
    <div className="nav-package">
      <div className="navbar">
        <Link to="/">
          <div className="logo">
            <Nysc style={{ width: "40px" }} />
            <div className="logo-text">
              <span className="word-nysc">NYSC</span>
              <span className="word-saed">SAED</span>
            </div>
          </div>
        </Link>
        <ul className={click ? "nav-menu active" : "nav-menu display"}>
          <li className="nav-item">
            <Link to="/about">About</Link>
          </li>
          <li className="nav-item">
            <Link to="/contactUs">Contact</Link>
          </li>
          <li className="nav-item">
            <Link to="#">Signup</Link>
          </li>
          {systemSettings.isTrainingCenterRegistrationActive && (
            <li className="nav-item">
              <Link to="/trainingCentreRegistration">
                Training Centre Registration{" "}
              </Link>
            </li>
          )}
          {/* <li className="nav-item dropdown" style={{ position: "relative" }}>
            <div className="dropdown-trigger" style={{ cursor: "pointer" }}>
              
                <Link
                  to="#"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: click ? colors.primaryGreen : "",
                    fontWeight: click ? 700 : 400,
                  }}
                  onClick={() => setClick(!click)}
                >
                  Training Centre Registration{" "}
                  <KeyboardArrowDownIcon style={{ marginTop: "2px" }} />
                </Link>
              
            </div>
            {click && (
              <ul
                className="dropdown-menu"
                style={{
                  listStyle: "none",
                  marginLeft: 20,
                  padding: 10,
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  borderRadius: 5,
                  background: "#fff",
                  boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                  zIndex: 1000,
                }}
              >
                <li style={{ padding: "10px 60px 10px 10px" }}>
                  <Link to="/trainingCentreRegistration" onClick={closeMenu}>
                    Fresh Registration
                  </Link>
                </li>
                <li style={{ padding: "10px" }}>
                  <Link
                    to="/trainingCentreRegistrationUpdate"
                    onClick={closeMenu}
                  >
                    Update Registration
                  </Link>
                </li>
              </ul>
            )}
          </li> */}
          <li className="nav-item">
            <Link to="/login">
              <button className="nav-btn">Login</button>
            </Link>
          </li>
        </ul>
        <div className="hamburger" onClick={handleClick}>
          {click ? (
            <FaTimes size={25} style={{ color: "#353535" }} />
          ) : (
            <FaBars size={25} style={{ color: "#353535" }} />
          )}
        </div>
      </div>
    </div>
  );
};
export default Header;
